import { render, staticRenderFns } from "./FeedEdit.vue?vue&type=template&id=702310be&"
import script from "./FeedEdit.vue?vue&type=script&lang=ts&"
export * from "./FeedEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports